// extracted by mini-css-extract-plugin
export default {"cancelTicket":"sidebar_cancelTicket__rkZQ+","list":"sidebar_list__9oXOH"};